// extracted by mini-css-extract-plugin
export default {"terms_service":"Service_terms_service__OdsUr"};